import anime from "animejs"
import confetti from 'canvas-confetti'

class NationalDay {
    constructor() {
        this.dContainer = document.getElementById('national-day-container')
        this.dPlanes = document.getElementsByClassName('national-day-plane')
        this.dParticles = []

        this.colors = ['#122753', '#ffffff', '#ba352f']
        this.planesCount = parseInt(this.dContainer.dataset.planesCount)
        this.sameColorPlanes = this.planesCount / this.colors.length
        this.duration = 20000
        this.end = Date.now() + this.duration;

        for (const el of this.dPlanes) {
            const canvas = el.getElementsByTagName('canvas')[0]

            canvas.confetti = canvas.confetti || confetti.create(canvas, {
                resize: true
            });

            this.dParticles.push(canvas)
        }
    }

    planes() {
        anime({
            targets: this.dPlanes,
            translateY: [
                this.dContainer.clientHeight * 1.1,
                -this.dContainer.clientHeight
            ],
            delay: anime.stagger(250, {
                from: 'center'
            }),
            easing: 'linear',
            duration: this.duration,
            loop: true,
            begin: () => this.animate(),
            loopComplete: () => {
                this.end = Date.now() + this.duration;
                this.animate()
                this.fireworks()
            }
        })
    }

    fireworks() {
        const opts = {
            startVelocity: 30,
            spread: 360,
            ticks: 60,
            zIndex: 0
        };

        const interval = setInterval(() => {
            const timeLeft = this.end - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / this.duration);

            confetti(Object.assign({}, opts, {
                particleCount,
                origin: {
                    x: this.randomInRange(0.1, 0.3),
                    y: Math.random() - 0.2
                }
            }));

            confetti(Object.assign({}, opts, {
                particleCount,
                origin: {
                    x: this.randomInRange(0.7, 0.9),
                    y: Math.random() - 0.2
                }
            }));
        }, 1000)
    }

    animate() {
        const now = Date.now()

        if (!(now % 3)) {
            for (let i = 0; i < this.dParticles.length; i++) {
                const color = i < this.sameColorPlanes ? this.colors[0] : i >= this.sameColorPlanes && i < this.sameColorPlanes * 2 ? this.colors[1] : this.colors[2]

                this.dParticles[i].confetti({
                    particleCount: 1,
                    ticks: 200,
                    angle: 90,
                    spread: 10,
                    origin: { x: 0.5, y: 0 },
                    colors: [color],
                    startVelocity: 2,
                    resize: true,
                    // useWorker: true
                });
            }
        }


        if (now < this.end) {
            requestAnimationFrame(() => this.animate());
        }
    }

    randomInRange(min, max) {
        return Math.random() * (max - min) + min
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const nationalDay = new NationalDay()

    nationalDay.planes()
    nationalDay.fireworks()
})